import React from 'react';
import Icon from '../ui/Icon';
import { T } from '../constants/mockData';

const activities = [
  { id: 1, type: "ticket_created", text: "Ticket #1024 was created", time: "10 mins ago", icon: "plus", color: "#3B5BDB" },
  { id: 2, type: "ticket_updated", text: "Status changed for Ticket #1020", time: "1 hour ago", icon: "edit", color: "#f59e0b" },
  { id: 3, type: "comment_added", text: "New comment on Ticket #1015", time: "2 hours ago", icon: "note", color: "#3b82f6" },
  { id: 4, type: "ticket_closed", text: "Ticket #1010 was closed", time: "1 day ago", icon: "check", color: "#64748b" },
];

export default function RecentActivityModal({ onClose }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(5,46,22,0.45)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: "#FFFFFF", borderRadius: 16, width: 450, maxHeight: "90vh", display: "flex", flexDirection: "column", boxShadow: "0 32px 80px rgba(5,46,22,0.22)" }}>
        <div style={{ padding: "20px 24px 18px", borderBottom: `1px solid ${T.border}`, background: `linear-gradient(135deg, ${T.g50} 0%, #fff 60%)`, borderRadius: "16px 16px 0 0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: 9, background: T.active, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 8px rgba(22,163,74,0.35)" }}>
              <Icon name="clock" size={16} color="#fff" />
            </div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#1A202C" }}>Recent Activity</div>
              <div style={{ fontSize: 11, color: T.muted, marginTop: 1 }}>Latest updates in the system</div>
            </div>
            <div style={{ flex: 1 }} />
            <button onClick={onClose} style={{ width: 30, height: 30, border: `1px solid ${T.border}`, borderRadius: 7, background: "#FFFFFF", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon name="close" size={14} color={T.muted} />
            </button>
          </div>
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px", display: "flex", flexDirection: "column", gap: 16 }}>
          {activities.map((act, index) => (
            <div key={act.id} style={{ display: "flex", gap: 12 }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ width: 32, height: 32, borderRadius: "50%", background: `${act.color}15`, display: "flex", alignItems: "center", justifyContent: "center", color: act.color }}>
                  <Icon name={act.icon} size={14} color={act.color} />
                </div>
                {index !== activities.length - 1 && <div style={{ width: 2, flex: 1, background: T.border, marginTop: 4 }}></div>}
              </div>
              <div style={{ paddingBottom: index !== activities.length - 1 ? 16 : 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#4A5568" }}>{act.text}</div>
                <div style={{ fontSize: 11, color: T.muted, marginTop: 4 }}>{act.time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
